import React, { Component } from 'react';
import { connect } from 'react-redux';
import { functionsService } from 'services';
import { FiPlus, FiMoreHorizontal, FiDownload } from 'react-icons/fi';
import { Dropdown } from 'react-bootstrap';
import Layout from 'components/Layout';
import Loading from 'components/Loading';
import FunctionEdit from 'components/Functions/FunctionEditModal';
import Modal from 'components/Modal';
import { showModal, hideModal } from 'actions/modalActions';
import * as functionsActions from 'actions/functionsActions';
import { errorFormating } from 'utils/utils';
import DataTable from 'components/DataTable';
import { withTranslation } from 'react-i18next';
import HelpBanner from 'components/HelpBanner';
import { helpUrls } from 'utils/helpUrls';

class Functions extends Component {
	constructor(props) {
		super(props);
		// console.log(props);

		this.closeModal = this.closeModal.bind(this);
		this.openNewFunctionModal = this.openNewFunctionModal.bind(this);
		this.openEditFunctionModal = this.openEditFunctionModal.bind(this);
		this.openAlertModal = this.openAlertModal.bind(this);
		this.getFunctions = this.getFunctions.bind(this);
	}

	componentDidMount() {
		this.getFunctions();
	}

	async getFunctions() {
		await this.props.getAllFunctions();
		//console.log(this.props);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewFunctionModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('functions.newFunction'),
				style: { width: '400px' },
				content: (
					<FunctionEdit
						getFunctions={this.getFunctions}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	openEditFunctionModal(func) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('functions.editFunction'),
				style: { width: '400px' },
				content: (
					<FunctionEdit
						function={func}
						getFunctions={this.getFunctions}
						handleClose={this.closeModal}
					/>
				),
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	openDeleteFunctionModal(idFunction) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('functions.deleteFunction'),
				style: { width: '400px' },
				message:
					this.props.t('functions.deleteConfirmation'),
				deleteAction: () => this.confirmDelete(idFunction),
				closeModal: this.closeModal,
			},
			'delete'
		);
	}

	openAlertModal(message) {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('functions.deleteError'),
				style: { width: '400px' },
				message: message,
				closeModal: this.closeModal,
			},
			'alert'
		);
	}

	confirmDelete = async (idFunction) => {
		const response = await functionsService.remove(idFunction);

		if (!response.ok) {
			let textError = errorFormating(response);
			this.openAlertModal(
				textError.general || textError.id || this.props.t('functions.deleteError')
			);
		} else {
			this.getFunctions();
			this.closeModal();
		}
	};

	getFunctionColumns = () => [
		{
			key: 'name',
			header: this.props.t('functions.headerFunction'),
			render: (func) => (
				<button
					type="button"
					className="btn-transparent btn-editable"
					onClick={() => this.openEditFunctionModal(func)}
				>
					{func.name}
				</button>
			),
		},
		{
			key: 'status',
			header: this.props.t('functions.headerStatus'),
			align: 'center',
			render: (func) =>
				func.enabled ? (
					<span title={this.props.t('common.active')} className="estado estado-si">
						{this.props.t('common.active')}
					</span>
				) : (
					<span title={this.props.t('common.inactive')} className="estado estado-no">
						{this.props.t('common.inactive')}
					</span>
				),
		},
		{
			key: 'color',
			sortable: false,
			header: '',
			headerTitle: 'Color',
			headerClassName: 'td-icon',
			align: 'center',
			className: 'td-icon',
			render: (func) => (
				<span
					className="bolita"
					style={{
						backgroundColor: func.background_color && func.background_color,
						borderColor: func.border_color && func.border_color,
					}}
				/>
			),
		},
	];

	getContent = () => {
		if (this.props.loading) {
			return <Loading />;
		}

		if (this.props.error) {
<div className="no-results">{this.props.t('functions.errorLoading')}</div>
		}

		const functions = this.props.functions || [];

		return (
			<DataTable
				tableClassName="table-functions table-hover"
				tableStyle={{ backgroundColor: '#ffffff' }}
				columns={this.getFunctionColumns()}
				rows={functions}
				rowKey={(row) => row.id}
				emptyMessage={this.props.t('functions.noFunctions')}
				actionsColumn={{
					render: (func) => (
						<Dropdown>
							<Dropdown.Toggle variant="action">
								<FiMoreHorizontal />
							</Dropdown.Toggle>
							<Dropdown.Menu>
								<Dropdown.Item
									as="button"
									onClick={() => this.openEditFunctionModal(func)}
								>
									{this.props.t("common.edit")}
								</Dropdown.Item>
								<Dropdown.Item
									as="button"
									onClick={() => this.openDeleteFunctionModal(func.id)}
								>
									{this.props.t("common.delete")}
								</Dropdown.Item>
							</Dropdown.Menu>
						</Dropdown>
					),
					className: 'td-actions',
				}}
			/>
		);
	};

	render() {
		return (
			<>
				<Layout
					configSidebar={true}
					className="page-functions"
					context="employees"
				>
					<div className="heading">
						<h1 className="title">{this.props.t('functions.title')}</h1>
						<div className="heading-help-banner heading-config hidden-sm">
							<HelpBanner
								title={this.props.t('common.needHelp')}
								text={this.props.t('common.helpText')}
								linkText={this.props.t('common.moreInfo')}
								linkHref={helpUrls.function}
							/>
						</div>

						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t('functions.createFunction')}
								onClick={this.openNewFunctionModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>
							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() => this.props.history.push('/functions/import')}
									>
										<FiDownload className="dropdown-icon" /> {this.props.t('functions.importFunctions')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return reducers.functionsReducer;
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getAllFunctions: (q) => dispatch(functionsActions.getAllFunctions(q)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Functions));
